import { SectionAccordion } from "@/pages/app/provider/patient/patient-list/patient-chart-new/patient-visit-note/encounter/note-forms/readmission-f2f";
import CodeSelectBlock from "./CodeSelectBlock";
import { useMedicalCodeOptions } from "../hooks/use-medical-code-options";
import { CodeBlockDef, CodeItem } from "../initial-f2f-types";
import { buildCodeSummaryEntries } from "../initial-f2f-utils";

export interface CodeSectionProps {
  title: string;
  block: CodeBlockDef;
  expanded: boolean;
  onToggle: () => void;
  codes: CodeItem[];
  onCodesChange: (codes: CodeItem[]) => void;
  freeText: string;
  onFreeTextChange: (value: string) => void;
}

const CodeSection = ({
  title,
  block,
  expanded,
  onToggle,
  codes,
  onCodesChange,
  freeText,
  onFreeTextChange,
}: CodeSectionProps) => {
  const { options, isLoading, setSearch } = useMedicalCodeOptions(
    block.type,
    expanded
  );

  return (
    <SectionAccordion
      title={title}
      expanded={expanded}
      onToggle={onToggle}
      summaryLines={buildCodeSummaryEntries(
        block.summaryLabel,
        codes,
        freeText,
        block.isNumbered
      )}
      unmountWhenCollapsed
    >
      <CodeSelectBlock
        block={block}
        options={options}
        isLoading={isLoading}
        onSearch={setSearch}
        codes={codes}
        onCodesChange={onCodesChange}
        freeText={freeText}
        onFreeTextChange={onFreeTextChange}
      />
    </SectionAccordion>
  );
};

export default CodeSection;
